import React, { useState, useEffect } from "react";
import "../../Assets/Styles/DailyTransaction.css";
import useApi from "../../utils/useApi";
function DailyTransaction() {
  const [transactions, setTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const { Get } = useApi();
  useEffect(() => {
    getTransactions();
  }, []); // Empty dependency array ensures this runs only once when the component mounts
  const getTransactions = async () => {
    try {
      const data = await Get("getTodaysTransactions");
      setTransactions(data);
      const total = data.reduce(
        (total, transaction) => total + Number(transaction.amount),
        0
      );
      setTotalAmount(total);
    } catch (error) {
      // console.error("Error fetching transactions:", error);
    }
  };
  return (
    <div className="transaction-container">
      {transactions && transactions.length > 0 ? (
        <div>
          <table className="transaction-table">
            <thead>
              <tr>
                <th></th>
                <th>V.No</th>
                <th>Name</th>
                <th>Group</th>
                <th>Sub No</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction) => (
                <tr key={transaction.id}>
                  <td>
                    {transaction.is_cash ? (
                      <img
                        width="30px"
                        height="30px"
                        src="assets/img/rupee.png"
                      />
                    ) : (
                      <img
                        src="assets/img/online-payment.png"
                        width="30px"
                        height="30px"
                      />
                    )}
                  </td>
                  <td>{transaction.voucher}</td>
                  <td>{transaction.user_full_name}</td>
                  <td>{transaction.group_title}</td>
                  <td>{transaction.subscription_no}</td>
                  <td>{transaction.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="total-amount">
            <strong>Total Amount: </strong>{" "}
            {totalAmount.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>
      ) : (
        <div>No transactions available.</div>
      )}
    </div>
  );
}
export default DailyTransaction;
